import React from 'react'
import styled from 'styled-components'

import ArquitecturaComp from './Arquitectura'
import CivilComp from './Civil'
import ComercialComp from './Comercial'
import DerechoComp from './Derecho'
import EnfermeriaComp from './Enfermeria'
import MedicinaComp from './Medicina'
import OdontologiaComp from './Odontologia'
import PeriodismoComp from './Periodismo'
import PsicologiaComp from './Psicologia'
import TablaDePosicionesComp from './TablaDePosiciones'
import CalidadDeLaGestionComp from './CalidadDeLaGestion'
import CalidadDelMercadoLaboralComp from './CalidadDelMercadoLaboral'
import CalidadDeLosAcademicosComp from './CalidadDeLosAcademicos'
import CalidadDeLosAlumnosComp from './CalidadDeLosAlumnos'
import CalidadDeLaInvestigacionComp from './CalidadDeLaInvestigacion'

const TablaWrap = styled.div`
  max-width: 100%;
  margin: 0 auto;
  @media (orientation: portrait) {
    max-width: 320px;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
`

const Arquitectura = () => {
  return (
    <TablaWrap>
      <ArquitecturaComp />
    </TablaWrap>
  )
}

const Civil = () => {
  return (
    <TablaWrap>
      <CivilComp />
    </TablaWrap>
  )
}

const Comercial = () => {
  return (
    <TablaWrap>
      <ComercialComp />
    </TablaWrap>
  )
}

const Derecho = () => {
  return (
    <TablaWrap>
      <DerechoComp />
    </TablaWrap>
  )
}

const Enfermeria = () => {
  return (
    <TablaWrap>
      <EnfermeriaComp />
    </TablaWrap>
  )
}

const Medicina = () => {
  return (
    <TablaWrap>
      <MedicinaComp />
    </TablaWrap>
  )
}

const Odontologia = () => {
  return (
    <TablaWrap>
      <OdontologiaComp />
    </TablaWrap>
  )
}

const Periodismo = () => {
  return (
    <TablaWrap>
      <PeriodismoComp />
    </TablaWrap>
  )
}

const Psicologia = () => {
  return (
    <TablaWrap>
      <PsicologiaComp />
    </TablaWrap>
  )
}

const TablaDePosiciones = () => {
  return (
    <TablaWrap>
      <TablaDePosicionesComp />
    </TablaWrap>
  )
}

const CalidadDeLaGestion = () => {
  return (
    <TablaWrap>
      <CalidadDeLaGestionComp />
    </TablaWrap>
  )
}

const CalidadDelMercadoLaboral = () => {
  return (
    <TablaWrap>
      <CalidadDelMercadoLaboralComp />
    </TablaWrap>
  )
}

const CalidadDeLosAcademicos = () => {
  return (
    <TablaWrap>
      <CalidadDeLosAcademicosComp />
    </TablaWrap>
  )
}

const CalidadDeLosAlumnos = () => {
  return (
    <TablaWrap>
      <CalidadDeLosAlumnosComp />
    </TablaWrap>
  )
}

const CalidadDeLaInvestigacion = () => {
  return (
    <TablaWrap>
      <CalidadDeLaInvestigacionComp />
    </TablaWrap>
  )
}

export {
  Arquitectura,
  Civil,
  Comercial,
  Derecho,
  Enfermeria,
  Medicina,
  Odontologia,
  Periodismo,
  Psicologia,
  TablaDePosiciones,
  CalidadDeLaGestion,
  CalidadDelMercadoLaboral,
  CalidadDeLosAcademicos,
  CalidadDeLosAlumnos,
  CalidadDeLaInvestigacion,
}
